// extracted by mini-css-extract-plugin
export default {"root":"PartyForm_root__rTJFg","edit-form":"PartyForm_edit-form__pEDeq"};